export const TEMPLATE_NAMES = {
    GLOBAL: "GLOBAL",
    HOME: "HOME",
    PLATFORM: "PLATFORMS",
    VMANICODE: "VMANICODE",
    VMANICODE_HOME: "VMANICODE-HOME",
    VMANICORI: "VMANICORI",
    VMANICORI_HOME: "VMANICORI-HOME",
    ITC_HOME: "ITC-HOME",
    PRODUCTS: "PRODUCTS",
    SOLUTIONS: "SOLUTIONS",
    COMPANY: "COMPANY",
    SERVICE: "SERVICE",
    BLOGS: "BLOGS",
    CAREERS: "CAREERS",
    VMANICO_HELPS: "VMANICO_HELPS",
    CONTACT_US: "CONTACT_US",
    ABOUT_US: "ABOUT_US",
    COOKIE_SETTINGS: "COOKIE_SETTINGS",
    why: "why"
}

export const SECTION_NAMES = {
    HEADER_SLIDES: "Slider-Slides",
    MENUBAR_ITEMS: "Menubar-Items",
    SUBMENU: "Submenu-",
    OPTIONS_LIST: "FormOptions-List",
    THEMES_LIST: "ThemeOptions-List",
    WHAT_IS_IP_HEADING: "SEC_WhatIsIP-Heading",
    WHAT_ARE_WE_OFFERING_HEADING: "SEC_WhatAreWeOffering-Heading",
    WHAT_ARE_WE_OFFERING_POINTS: "SEC_WhatAreWeOffering-Points",
    WHY_ARE_WE_DIFFERENT_HEADING: "SEC_WhyAreWeDifferent-Heading",
    WHY_ARE_WE_DIFFERENT_CARD: "SEC_WhyAreWeDifferent-Card",
    OUR_PLATFORMS_HEADING: "SEC_OurPlatforms-Heading",
    OUR_PLATFORMS_CARD: "SEC_OurPlatforms-Card",
    INDUSTRIES_SERVED_HEADING: "SEC_IndustriesServed-Heading",
    INDUSTRIES_SERVED_CARD: "SEC_IndustriesServed-Card",
    BUSINESS_STRATEGY_HEADING: "SEC_BusinessStrategy-Heading",
    BUSINESS_STRATEGY_CARD: "SEC_BusinessStrategy-Card",
    MAIN_SECTION_HEADING: "SEC_MainSection-Heading",
    MAIN_SECTION_INTERNAL_POINTS: "SEC_MainSectionInternal-Points",
    MAIN_SECTION_EXTERNAL_POINTS: "SEC_MainSectionExternal-Points",
    MAIN_SECTION_BUILD_BUY_SUBSCRIPTION: "SEC_MainSectionBuildBuySubscription",
    TESTIMONIALS_HEADING: "SEC_Testimonials-Heading",
    TESTIMONIALS_CARD: "SEC_Testimonials-Card",
    WHY_ENGAGE_WITH_US_HEADING: "SEC_WHyEngageWithUs-Heading",
    WHY_ENGAGE_WITH_US_CARD: "SEC_WHyEngageWithUs-Cards",
    CAREERS_HEADING: "SEC_Careers-Heading",
    CAREERS_CARD: "SEC_Careers-Cards",
    WHY_CHOOSE_US_HEADING: "SEC_WhyChooseUs-Heading",
    WHY_CHOOSE_US_ITEMS: "SEC_WhyChooseUs-Items",
    OUR_PARTNERS_HEADING: "SEC_Partners-Heading",
    OUR_PARTNERS_CARD: "SEC_Partners-Card",
    WHO_WE_ARE_HEADING: "SEC_WhoWeAre-Heading",
    WHO_WE_ARE_CARD: "SEC_WhoWeAre-Card",
    STORY_TELLING_HEADING: "SEC_StoryTelling-Heading",
    STORY_TELLING_CARD: "SEC_StoryTelling-Card",
    STORY_TELLING_TABS: "SEC_StoryTelling-Tabs",
    STORY_TELLING_STEPPER: "SEC_StoryTelling-Stepper",
    OUR_PRODUCTS_HEADING: "SEC_OurProducts-Heading",
    OUR_PRODUCTS_CARD: "SEC_OurProducts-Card",
    WE_CARE_HEADING: "SEC_WeCare-Heading",
    WE_CARE_ITEMS: "SEC_WeCare-Items",
    FUTURE_PROOF_SCALABILITY_HEADING: "SEC_FutureProofScalability-Heading",
    FUTURE_PROOF_SCALABILITY_POINTS: "SEC_FutureProofScalability-Points",
    INDUSTRY_LEADING_SECURITY_HEADING: "SEC_IndustryLeadingSecurity-Heading",
    INDUSTRY_LEADING_SECURITY_POINTS: "SEC_IndustryLeadingSecurity-Points",
    RETURN_OF_INVESTMENT_HEADING: "SEC_ReturnOfInvestment-Heading",
    RETURN_OF_INVESTMENT_POINTS: "SEC_ReturnOfInvestment-Points",
    EMPOWER_WORKFORCE_HEADING: "SEC_EmpowerWorkforce-Heading",
    EMPOWER_WORKFORCE_POINTS: "SEC_EmpowerWorkforce-Points",
    SEAMLESS_INTEGRATION_HEADING: "SEC_SeamlessIntegration-Heading",
    SEAMLESS_INTEGRATION_POINTS: "SEC_SeamlessIntegration-Points",
    EMPOWERING_COLLABORATION_HEADING: "SEC_EmpoweringCollaboration-Heading",
    EMPOWERING_COLLABORATION_POINTS: "SEC_EmpoweringCollaboration-Points",
    DRIVE_BUSINESS_DECISIONS_HEADING: "SEC_DriveBusinessDecisions-Heading",
    DRIVE_BUSINESS_DECISIONS_POINTS: "SEC_DriveBusinessDecisions-Points",
    EFFORTLESS_ONBOARDING_HEADING: "SEC_EffortlessOnboarding-Heading",
    EFFORTLESS_ONBOARDING_POINTS: "SEC_EffortlessOnboarding-Points",
    SUPERIOR_CHOICE_HEADING: "SEC_SuperiorChoice-Heading",
    SUPERIOR_CHOICE_POINTS: "SEC_SuperiorChoice-Points",
    BENEFITS_HEADING: "SEC_Benefits-Heading",
    BENEFITS_ITEMS: "SEC_Benefits-Items",
    PLANS: "SEC_Plans-",
    COMMUNICATION_HEADING: "SEC_Communication-Heading",
    COMMUNICATION_ITEMS: "SEC_Communication-Items",
    OUR_TEAM_HEADING: "SEC_OurTeam-Heading",
    OUR_TEAM_CARD: "SEC_OurTeam-Card",
    BIG_REASONS_HEADING: "SEC_BigReasons-Heading",
    BIG_REASONS_ITEMS: "SEC_BigReasons-Items",
    BIG_REASONS_POINTS: "SEC_BigReasons-Points",
    BIG_REASONS_CONTENTS: "SEC_BigReasons-Contents",
    SEC_SOFTWARE_HEADING: "SEC_Software-Heading",
    SEC_SOFTWARE_CARD: "SEC_Software-card",
    VMANICO_HELPS_HEADING: "SEC_VmanicoHelps-Heading",
    VMANICO_HELPS_POINTS: "SEC_VmanicoHelps-Points",
    CONTACT_US_CARDS: "SEC_ContactUsInformation-Card",
    ABOUT_US_INTRO_HEADING: "SEC_AboutUsIntroduction-Heading",
    SOLUTIONS_HEADING: "SEC_ComprehensiveSolutions-Heading",
    SOLUTIONS_POINTS: "SEC_ComprehensiveSolutions-Points",
    OUR_EXPERTISE_HEADING: "SEC_OurExpertise-Heading",
    OUR_EXPERTISE_CARDS: "SEC_OurExpertise-Cards",
    OUR_EXPERTISE_POINTS: "SEC_OurExpertise-Points",
    PRICING_HEADING: "SEC_Pricing-Heading",
    PRICING_POINTS: "SEC_Pricing-Points",
    My_heading: "SEC_MYWeAre-Heading",
    content_Rid: "SEC_MYCare-Heading",
    whoits: "SEC_WhyIt'sDifferent",
    Low_code: "SEC_Low-Code/No-Code",
    WHY_WE_STAND_OUT_HEADING: "SEC_WhyWeStandOut-Heading",
    WHY_WE_STAND_OUT_POINTS: "SEC_WhyWeStandOut-Points",
    WHAT_SETS_US_APART_HEADING: "SEC_WhatSetsUsApart-Heading",
    WHAT_SETS_US_APART_POINTS: "SEC_WhatSetsUsApart-Points",
    COOKIES_CONSENT_HEADING: "SEC_CookiesConsent-Heading",
    COOKIES_CONSENT_ITEMS: "SEC_CookiesConsent-Items",
    FOOTER_LINKS: "Footer-Links",
    whatis: "SEC_whatweare-Heading",
    FOOTER_SOCIALS: "Footer-Socials",
    CONCLUSION: "SEC_Conclusion",
    UNLOCK_POWER_DEVELOPMENT: "SEC_UnlockPowerDevelopment",
    KEY_BENEFITS: "SEC_KeyBenefits",
    USER_EXPERIENCE_HEADING: "SEC_UserExperience-Heading",
    USER_EXPERIENCE_POINTS: "SEC_UserExperience-Points",
    ADOPTION_LEVELS_HEADING: "SEC_AdoptionLevels-Heading",
    ADOPTION_LEVELS_ITEMS: "SEC_AdoptionLevels-Items",
    INTEGRATION_ECOSYSTEM_HEADING: "SEC_IntegrationEcosystem-Heading",
    INTEGRATION_ECOSYSTEM_POINTS: "SEC_IntegrationEcosystem-Points",
    BEST_TRENDS_HEADING: "SEC_BestTrends-Heading",
    BEST_TRENDS_CARDS: "SEC_BestTrends-Cards",
    SOLUTION_USECASES_HEADING: "SEC_SolutionsUseCases-Heading",
    SOLUTION_USECASES_POINTS: "SEC_SolutionsUseCases-Points",
    BUSINESS_NEEDS_HEADING: "SEC_BusinessNeeds-Heading",
    BUSINESS_NEEDS_POINTS: "SEC_BusinessNeeds-Points",
    NOCODE_LOWCODE_SOLUTIONS_HEADING: "SEC_NoCodeLowCodeSolutions-Heading",
    NOCODE_LOWCODE_SOLUTIONS_POINTS: "SEC_NoCodeLowCodeSolutions-Points",
    VMANICODE_POINTS: "SEC_Vmanicode-Points",
    SAFEGUARDING_PROPERTY_HEADING: "SEC_SafeGuardingProperty-Heading",
    UNLOCK_THE_FUTURE: "SEC_UnlockTheFuture",
    DOCUMENT_MANAGEMENT_HEADING: "SEC_DocumentManagement-Heading",
    DOCUMENT_MANAGEMENT_POINTS: "SEC_DocumentManagement-Points",
    WORKFORCE_MANAGEMENT_HEADING: "SEC_WorkforceManagement-Heading",
    WORKFORCE_MANAGEMENT_POINTS: "SEC_WorkforceManagement-Points",
    INDUSTRY_CHALLANGES_HEADING: "SEC_IndustryChallanges-Heading",
    INDUSTRY_CHALLANGES_POINTS: "SEC_IndustryChallanges-Points",
    SMART_RECRUITMENTS_HEADING: "SEC_SmartRecruitment-Heading",
    SMART_RECRUITMENTS_POINTS: "SEC_SmartRecruitment-Points",
    PAYROLL_AUTOMATION_HEADING: "SEC_PayrollAutomation-Heading",
    PAYROLL_AUTOMATION_POINTS: "SEC_PayrollAutomation-Points",
    HUMAN_CAPITAL_POTENTIAL_HEADING: "SEC_HumanCapitalPotential-Heading",
    HUMAN_CAPITAL_POTENTIAL_POINTS: "SEC_HumanCapitalPotential-Points",
    PROTECTING_BUSINESS_DATA_HEADING: "SEC_ProtectingBusinessData-Heading",
    PROTECTING_BUSINESS_DATA_POINTS: "SEC_ProtectingBusinessData-Points",
    ADAPTING_BUSINESS_GROWTH_HEADING: "SEC_AdaptingBusinessGrowth-Heading",
    ADAPTING_BUSINESS_GROWTH_POINTS: "SEC_AdaptingBusinessGrowth-Points",
    INDUSTRY_TRENDS_HEADING: "SEC_IndustryTrends-Heading",
    INDUSTRY_TRENDS_POINTS: "SEC_IndustryTrends-Points",
    MODERN_BUSINESS_SOLUTIONS_HEADING: "SEC_ModernBusinessSolutions-Heading",
    MODERN_BUSINESS_SOLUTIONS_POINTS: "SEC_ModernBusinessSolutions-Points",
    STRATEGY_TO_DELIVERY_HEADING: "SEC_StrategyToDelivery-Heading",
    STRATEGY_TO_DELIVERY_POINTS: "SEC_StrategyToDelivery-Points",
    EMPOWER_YOUR_CAREER_HEADING: "SEC_EmpowerYourCareer-Heading",
    EMPOWER_YOUR_CAREER_POINTS: "SEC_EmpowerYourCareer-Points",
    DAILY_NEWS_HEADING: "SEC_DailyNews-Heading",
    DAILY_NEWS_POINTS: "SEC_DailyNews-Points",
    BUSINESS_QUOTES_HEADING: "SEC_BusinessQuotes-Heading",
    TOP_EMPLOYEE_POINTS: "SEC_TopEmployees-Points",
    BOLD_SOLUTIONS_HEADING: "SEC_BoldSolutions-Heading",
    BOLD_SOLUTIONS_POINTS: "SEC_BoldSolutions-Points",
    IDEAS_FOR_FUTURE_HEADING: "SEC_IdeasForFuture-Heading",
    IDEAS_FOR_FUTURE_POINTS: "SEC_IdeasForFuture-Points",
    LONGTERM_PLANNING_HEADING: "SEC_LongTermPlanning-Heading",
    OUR_ANALYSIS_HEADING: "SEC_OurAnalysis-Heading",
    OUR_ANALYSIS_POINTS: "SEC_OurAnalysis-Points",
    MONITORING_AND_EVALUATING_HEADING: "SEC_MonitoringAndEvaluating-Heading",
    OUR_GOALS_HEADING: "SEC_OurGoals-Heading",
    OUR_GOALS_POINTS: "SEC_OurGoals-Points",
    CLOUD_COMPUTING_SOLUTION_HEADING: "SEC_CloudComputingSolution-Heading",
    CLOUD_COMPUTING_SOLUTION_POINTS: "SEC_CloudComputingSolution-Points",
    INVESTMENT_AFTER_PANDEMIC_HEADING: "SEC_InvestmentAfterPandemic-Heading",
    HELPING_CLIENTS_HEADING: "SEC_HelpingClients-Heading",
    IMPROVE_COMPANY_BRAND_HEADING: "SEC_ImprovingCompanyBrand-Heading",
    BEST_PROFESSIONAL_TEAM_HEADING: "SEC_BestProffessionalTeam-Heading",
    BEST_PROFESSIONAL_TEAM_POINTS: "SEC_BestProffessionalTeam-Points",
    EXPERT_CONSULTATION_HEADING: "SEC_ExpertConsultation-Heading",
    EXPERT_CONSULTATION_POINTS: "SEC_ExpertConsultation-Points",
    NO_CODE_LOW_CODE_SOLUTION_HEADING: "SEC_NoCodeLowCodeSolution-Heading",
    NO_CODE_LOW_CODE_SOLUTION_POINTS: "SEC_NoCodeLowCodeSolution-Points",
    BUSINESS_INVESTMENTS_ITEMS: "SEC_BusinessInvestments-Items",
    INVESTMENTS_IN_STOCK_HEADING: "SEC_InvestmentsInStock-Heading",
    MISSION_VISION_POINTS: "SEC_MissionVision-Points",
    IT_STRATEGY_CONSULTING_HEADING: "SEC_ITStrategyConsulting-Heading",
    IT_STRATEGY_CONSULTING_CARD: "SEC_ITStrategyConsulting-Card",
    DIGITAL_TRANSFORMATION_CONSULTING_HEADING: "SEC_DigitalTransformationConsulting-Heading",
    SCHOOL_PROFESSORS_HEADING: "SEC_SchoolProfessors-Heading",
    SCHOOL_PROFESSORS_POINTS: "SEC_SchoolProfessors-Points",
    CYBER_SECURITY_SOLUTIONS_HEADING: "SEC_CyberSecuritySolutions-Heading",
    CYBER_SECURITY_SOLUTIONS_POINTS: "SEC_CyberSecuritySolutions-Points",
    CUTTING_EDGE_TECHNOLOGIES_HEADING: "SEC_CuttingEdgeTechnologies-Heading",
    CUTTING_EDGE_TECHNOLOGIES_POINTS: "SEC_CuttingEdgeTechnologies-Points",
    SCALABILITY_AND_FLEXIBILITY_HEADING: "SEC_ScalabilityAndFlexibility-Heading",
    EMPOWER_YOUR_BUSINESS_HEADING: "SEC_EmpowerYourBusiness-Heading",
    IT_STRATEGY_ADVISORY_HEADING: "SEC_ItStrategyAdvisory-Heading",
    IT_STRATEGY_ADVISORY_POINTS: "SEC_ItStrategyAdvisory-Points",
    EXPERT_INSIGHTS_HEADING: "SEC_ExpertInsights-Heading",
    EXPERT_INSIGHTS_POINTS: "SEC_ExpertInsights-Points",
    TRANSFORM_YOUR_FUTURE_HEADING: "SEC_TransformYourFuture-Heading",
    TRANSFORM_YOUR_FUTURE_POINTS: "SEC_TransformYourFuture-Points",
    CLIENT_TESTIMONIALS_HEADING: "SEC_ClientTestimonials-Heading",
    CLIENT_TESTIMONIALS_POINTS: "SEC_ClientTestimonials-Points",
}

export const REGIONS = [
    {
        code: "USA",
        name: "USA",
        routerLink: "https://vmanico.com/"
    },
    {
        code: "INDIA",
        name: "India",
        routerLink: "https://vmanico.in/"
    }
];

export enum FORM_TYPE {
    HELP = 1,
    CONTACT_US = 2,
    CUSTOM_PLAN = 3,
    NEWS_LETTER_SUBSCRIPTION = 4,
}

export const COOKIE_STORAGE = {
    COOKIE_CONSENT: "vmanico-consent",
    HELP: "help",
    CONTACT_US: "contact-us",
    SUPPORT: "support",
    CUSTOM_PLAN: "customPlanForm",
    NEWS_LETTER: "joinNewsletterForm",
    LOCAL_IP_ADDRESS: "10.10.10.10",
}

export const SERVER_ENDPOINTS = {
    INDIA: "https://vmanico.in/",
    USA: "https://vmanico.com/",
}

export const API_ROUTES = {
    COUNTRIES: "/registration/countries",
    PROVIDERS: "/registration/providers/",
    REGISTER: "/registration/register",
    CONTACT_US: "/registration/contact-us",
    // SUPPORT_REQUEST: "/registration/support-request",
    // REPORT_OUTTAGE: "/registration/outage-notification",
    SUPPORT_REQUEST: "/registration/outage-notification",
    REPORT_OUTTAGE: "/registration/support-request",
    PROFILE_SUBSCRIPTION: "/user/profile/subscriptions",
    PROFILE: "/user/profile",
    DETAILED_PROFILE: "/user/profile/full_info",
    ROLE: "/user/role",
    ROLES_LIST: "/user/roles_list",
    BROUCHER: "/broucher/",
    PROFILE_IMAGE: "/profile-image",
    USER_LOGIN: "/user/login",
    RESEND_OTP: "/user/resend_user_otp",
    VERIFY_OTP: "/user/verify_login_register_contact_user_otp",
    CHANGE_PASSWORD: "/user/change_password",
    FORGOT_PASSWORD: "/user/forgot_password",
    RESET_PASSWORD: "/user/reset_password",
    VERIFY_FORGOT_PASSWORD: "/user/verify_forgotpassword_user_otp",
    REFRESH_TOKEN: "/user/refresh_with_token",
    REFRESH_LOGIN: "/user/refresh_login",
    SEARCH_REQUIREMENTS: "/search/requirements",
    JOB_DETAILS: "/jobs/",
    JOB_APPLY: "/job/apply",
    LOGOUT: "/user/logout",
    GLOBAL_CONSENT: "/global/consent",
    PROFILE_CONSENT: "/user/profile/consent",
}